import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import axios from "axios";
import Autosuggest from "react-autosuggest";
import { useCookies } from "react-cookie";
import bxsTrash from '@iconify/icons-bx/bxs-trash';
import Icon from "@iconify/react";

const PresupuestosConfiguracionAddModal = ({
    show,
    onHide,
    onSave
}) => {

    const [cookie] = useCookies(['kUserSession']);
    
    const [categoria, setCategoria] = useState({
        categoria: "",
        tipoCategoriaPresupuesto: "PRESUPUESTO",
        cuentas: []
    });

    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [account, setAccount] = useState(0);
    const [name, setName] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    const handleChange = (field, value) => {
        setCategoria({ ...categoria, [field]: value });
    };

    const prepareHeaders = () => ({
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            "api_key": "k-randa",
            "access_token": cookie.kUserSession.data.access_token
        }
    });

    const searchSuggestions = ({ value }) => {
        setSuggestions(getSuggestions(value));
    };

    const clearSuggestions = () => {
        setSuggestions([]);
    };

    const onChangeName = (event, { newValue }) => {
        setName(newValue);
    };

    const inputProps = {
        placeholder: "Escriba la cuenta",
        value: name,
        onChange: onChangeName,
        autocomplete: "off"
    };

    const getSuggestions = value => {
        const inputValue = value.toLowerCase();
        return accounts.filter(lang =>
            (lang.descripcion.toLowerCase() + lang.codigo).includes(inputValue)
        );
    };

    const getSuggestionValue = (suggestion) => {
        setAccount(suggestion.id);
        return suggestion.codigo + " - " + suggestion.descripcion;
    };

    const renderSuggestion = (suggestion) => (
        <span>{suggestion.codigo + " - " + suggestion.descripcion}</span>
    );

    const retrieveAccountingAccounts = () => {
        setAccountsLoading(true);
        const currentFarm = cookie.kUserSession.data["farm"];
        axios.get(process.env.REACT_APP_API_URL + "accountancy/accounts?id_estancia=" + currentFarm.id + "&tipo=P", prepareHeaders())
            .then(rs => {
                if (rs.status === 200) {
                    const { data } = rs.data;
                    setAccounts(data);
                } else {
                    setAccounts([]);
                }
                setAccountsLoading(false);
                setAccount(0);
            })
            .catch(error => {
                console.error(error);
                setAccounts([]);
                setAccountsLoading(false);
                setAccount(0);
            });
    };

    const searchAccount = (id) => {
        return accounts.find(a => parseInt(a.id) === parseInt(id)) || {};
    };

    const addDetail = (e) => {
        e.preventDefault();
        if (account !== 0) {
            const detail = searchAccount(account);
            setCategoria(prev => ({
                ...prev,
                cuentas: [...prev.cuentas, detail]
            }));
            setAccount(0);
            setName("");
        }
    };

    const removeFromDetails = (e, detail) => {
        e.preventDefault();
        setCategoria(prev => ({
            ...prev,
            cuentas: prev.cuentas.filter(c => c.id !== detail.id)
        }));
    };

    const guardarCategoria = () => {
        onSave(categoria);
    };

    useEffect(() => {
        if (show) {
            retrieveAccountingAccounts();
            setCategoria({
                categoria: "",
                tipoCategoriaPresupuesto: "PRESUPUESTO",
                cuentas: []
            });
            setAccount(0);
            setName("");
        }
    }, [show]);

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Registrar nueva categoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: "bold" }}>Categoría</Form.Label>
                        <Form.Control
                            className="karanda-input"
                            type="text"
                            value={categoria.categoria}
                            onChange={(e) => handleChange("categoria", e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: "bold" }}>Tipo</Form.Label>
                        <Form.Control
                            as="select"
                            className="karanda-input"
                            value={categoria.tipoCategoriaPresupuesto}
                            onChange={(e) => handleChange("tipoCategoriaPresupuesto", e.target.value)}
                        >
                            <option value="PRESUPUESTO">PRESUPUESTO</option>
                            <option value="INVERSION">INVERSION</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="cuenta">
                        <Form.Label style={{ fontWeight: "bold" }}>Cuenta contable</Form.Label>
                        <Row>
                            <Col>
                                <Autosuggest
                                    suggestions={suggestions}
                                    onSuggestionsFetchRequested={searchSuggestions}
                                    onSuggestionsClearRequested={clearSuggestions}
                                    getSuggestionValue={getSuggestionValue}
                                    renderSuggestion={renderSuggestion}
                                    inputProps={inputProps}
                                />
                            </Col>
                            <Col md="auto">
                                <Button size="sm" onClick={addDetail}>Agregar</Button>
                            </Col>
                        </Row>

                        {
                            categoria.cuentas.length > 0 && (
                                <Row style={{ padding: "20px" }}>
                                    <Table className="karanda-table" style={{ marginTop: ".5rem" }}>
                                        <tbody>
                                            {
                                                categoria.cuentas.map((i) => (
                                                    <tr key={i.id}>
                                                        <td style={{ textAlign: "left" }}>{i.codigo + " - " + i.descripcion}</td>
                                                        <td>
                                                            <Icon icon={bxsTrash} style={{ cursor: "pointer" }} width="15px" onClick={(e) => removeFromDetails(e, i)} />
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Row>
                            )
                        }
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={guardarCategoria}>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PresupuestosConfiguracionAddModal;